import { ReactNode } from "react";
import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

type SettingsSectionProps = {
  title: string;
  description?: ReactNode;
  children: ReactNode;
};

/** One titled block of a settings page. Sections stack with a divider between each. */
function SettingsSection({ title, description, children }: SettingsSectionProps): JSX.Element {
  return (
    <Section aria-label={title}>
      <Flex column gap={4}>
        <Text h2>{title}</Text>
        {description && (
          <Text description color="sysTextSecondary">
            {description}
          </Text>
        )}
      </Flex>
      {children}
    </Section>
  );
}

export default SettingsSection;

const Section = styled.section(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 16,
  paddingBottom: 32,
  "&:not(:last-of-type)": {
    borderBottom: `1px solid ${theme.colors.sysBorderDecorative}`,
  },
}));
